function arrayBufferToBase64(buffer) {
  let binary = '';
  let bytes = new Uint8Array(buffer);
  let length = bytes.byteLength;
  for (let i = 0; i < length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

function pemToBase64(pem) {
  let lines = pem.split('\n');
  let encoded = '';
  for (let i = 0; i < lines.length; i++) {
    if (lines[i].trim().length > 0 &&
      lines[i].indexOf('-BEGIN PUBLIC KEY-') < 0 &&
      lines[i].indexOf('-END PUBLIC KEY-') < 0) {
      encoded += lines[i].trim();
    }
  }
  return encoded;
}

function stringToArrayBuffer(str) {
  const buf = new ArrayBuffer(str.length);
  const bufView = new Uint8Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

async function rsaEncrypt(publicKey, message) {
  let encryptedMessage = await window.crypto.subtle.encrypt(
    {
      name: "RSA-OAEP"
    },
    publicKey,
    new TextEncoder().encode(message) // Array buffer of message
  );

  return new Uint8Array(encryptedMessage);
}

async function importPublicKey(pem) {
  // 将PEM格式的公钥转换为适用于Web Cryptography API的格式
  let base64String = pemToBase64(pem);
  let binaryString = window.atob(base64String);
  let binaryKey = stringToArrayBuffer(binaryString);

  // 导入公钥
  return await window.crypto.subtle.importKey(
    "spki",
    binaryKey,
    {
      name: "RSA-OAEP",
      hash: "SHA-256"
    },
    false,
    ["encrypt"]
  );
}

export async function encrypt(pubkeypem, text) {
  let pubkey = await importPublicKey(pubkeypem);
  let encryptedMessage = await rsaEncrypt(pubkey, text);
  return arrayBufferToBase64(encryptedMessage);
}
